<template>
  <Row>
    <Row type="flex" justify="end" style="margin:12px 0;">
      <Page
        show-total
        :total="page.total"
        size="small"
        @on-change="changePage"
        show-sizer
        :page-size="page.limit"
        @on-page-size-change="changeLimit"
        :page-size-opts="[10, 20, 30, 40, 50, 60, 80]"
      ></Page>
      <i-button size="small" @click="download">
        <FFIcon type="download" aria-hidden="true" />download
      </i-button>
    </Row>

    <Row>
      <AgGridVue
        style="width: 100%; height: 640px;"
        class="ag-theme-balham"
        :rowData="dataset"
        :columnDefs="columnDefs"
        :gridOptions="gridOptions"
      ></AgGridVue>
    </Row>

    <Row type="flex" justify="end" style="margin:12px 0;">
      <Page
        show-total
        :total="page.total"
        size="small"
        @on-change="changePage"
        show-sizer
        :page-size="page.limit"
        @on-page-size-change="changeLimit"
        :page-size-opts="[10, 20, 30, 40, 50, 60, 80]"
      ></Page>
      <i-button size="small" @click="download">
        <FFIcon type="download" aria-hidden="true" />download
      </i-button>
    </Row>
  </Row>
</template>

<script>
import tableActions from "@/mixins/table_actions.js";
import pagination from "@/mixins/pagination.js";
import sort from "@/mixins/sort.js";
import { AgGridVue } from "ag-grid-vue";
import CopyButton from "@/grid-components/copy-button.vue";
import LinkComponent from "@/grid-components/link.vue";
import TagsComponent from "@/grid-components/tags";

export default {
  components: {
    AgGridVue,
    /* eslint-disable vue/no-unused-components */
    CopyButton,
    /* eslint-disable vue/no-unused-components */
    LinkComponent,
  },
  mixins: [tableActions, pagination, sort],
  props: ["conditions", "limit"],

  data() {
    return {
      tableURL: "events_view",
      dataset: [],
      gridOptions: {
        sideBar: {
          toolPanels: ["columns", "filters"],
          defaultToolPanel: "",
        },
        defaultColDef: {
          sortable: true,
          resizable: true,
          filter: true,
        },
        enableRangeSelection: true,
        allowContextMenuWithControlKey: true,
        getContextMenuItems: params => [
          {
            name: "Copy URL",
            action: () => {
              this.copyClipboard(params.node.data);
            },
          },
          "separator",
          ...params.defaultItems,
        ],
      },
      columnDefs: Object.freeze([
        {
          headerName: "Name",
          field: "name",
          width: 420,
          cellRendererFramework: LinkComponent,
          cellRendererParams: {
            link: data => `/events/${data.id}`,
            name: data => data.name,
          },
        },
        {
          headerName: "Figure",
          field: "recommended_figure",
          valueFormatter: ({ value }) => {
            if (!!value) {
              return value.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,");
            } else {
              return "";
            }
          },
          width: 80,
        },
        {
          headerName: "Type",
          field: "type",
          width: 160,
          enableRowGroup: true,
        },
        {
          headerName: "Countries",
          field: "geo_name",
          cellRendererFramework: TagsComponent,
          cellRendererParams: {
            items: data => data.geo_name || [],
          },
        },
        { headerName: "Year", field: "year", width: 70, enableRowGroup: true },
        {
          headerName: "Cause",
          field: "displacement_type",
          width: 90,
          enableRowGroup: true,
        },
        { headerName: "Facts", field: "fact_count", width: 90 },
        { headerName: "Start Date", field: "start_date", width: 120 },
        {
            headerName: "Included in GRID",
            field: "data_included",
            width: 160,
            cellRenderer: params => (params.value ? '<i class="fa fa-check-circle"></i>': ""),
        },
        {
          headerName: "Category",
          field: "category",
          width: 160,
          enableRowGroup: true,
          hide: true,
        },
        {
          headerName: "Sub-Category",
          field: "subcategory",
          width: 160,
          enableRowGroup: true,
          hide: true,
        },
        {
          headerName: "Sub-Type",
          field: "subtype",
          width: 160,
          enableRowGroup: true,
          hide: true,
        },
        {
          headerName: "Regions",
          field: "region",
          cellRendererFramework: TagsComponent,
          cellRendererParams: {
            items: data => data.region || [],
          },
          hide: true,
        },
      ]),
    };
  },

  copyClipboard(data) {
    const link = `${window.origin}/facts/${data.id}`;
    this.$copyText(link).then(
      () => this.$Message.success("Link copied to clipboard"),
      () => this.$Message.error("Can't copy link")
    );
  },

  created() {
    this.load();
  },

  watch: {
    conditions() {
      this.load();
    },
  },
};
</script>

<style lang="css">
.ivu-table-small td {
  height: 32px;
}
</style>
